/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';

/*------------------------------------*\
    HORSE CONTACT
\*------------------------------------*/
class HorseContact {
    constructor(passedElement) {
        let self = this;
        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;

        // Prepare horse_id to pass to modal window
        $('#contactModal').on('show.bs.modal', function(e) {
            var horseId = $(e.relatedTarget).data('horse-id');
            // Populate hidden horse_id field with param
            $(e.currentTarget).find('input[name="horse_id"]').val(horseId);
        });

        const axios = require('axios');
        const form = document.querySelector('.horse-contact'); 
        form.addEventListener('submit', (e) => { 
            //to prevent reload after submit
            e.preventDefault();

            //form data 
            var endpoint = document.getElementById("endpoint").value;
            var id = document.getElementById("horse_id").value;
            var name = document.getElementById("name").value;
            var telephone = document.getElementById("telephone").value;
            var email = document.getElementById("email").value;
            var relationship = document.getElementById("relationship").value;
            var reason = document.getElementById("reason").value;

            axios.get(endpoint + '/api/horse/' + id + '/contact?name=' + name + '&email=' + email + '&telephone=' + telephone + '&relationship=' + relationship + '&reason=' + reason, {
                headers: {
                    'key': 'zGNhtVA23EkmSqbLFM7Z5pV5Z3FEwX',
                    'secret': '9FU]^b(e-tafe{C)>9U%&m7%9pZ~+}=5hVSU;{_D',
                }
            }) 
            .then((res)=>{ 
                console.log(res);
                $('#contactModal').modal('hide');
                $('#successModal').modal('show');
            }) 
            .catch((err) => {throw err});
        });
    };
}

export default HorseContact;
